import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { Subject, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DatastoreService {
  startQuestions: any;
  type_of_ceramony: any;
  public totalCost: any;
  public firstSlotAnalytic: any;
  public firstSlotAnalyticKey: string;

  public reference: any;

  public originalCompanyId: any;

  // client details
  public booker_first_name: any
  public booker_last_name: any
  public booker_email: any
  public booker_phone: any

  public costBreakDown: any;

  public setService: any;
  public setResource: any;

  public extraDuration: Number = 0; // obtained from questions

  constructor() { }

  public bookingQuestions = [];

  public unselectedLocations = []

  public bookingForm;
  public companyAnswers;

  public selectedDate;

  public selectedSlot;

  public selectedResource;

  public selectedService; //used only to store the service incase we switch to the alt one
  public selectedDepartment; //used only to store the service incase we switch to the alt one

  public locations = [];

  public bookingAnswers;

  public customerDetailsForm;

  public client;

  public clientCreated: boolean = false;

  public address;

  public latitude;

  public longitude;

  public endSlot;

  public customerQuestions;

  public companyQuestions;

  public address1

  public companyQuestionsForm;

  public selectedLocation;

  public booking;

  public totalPrice;

  public adminJourney: boolean = false;

  public adminAuthToken: string = '';

  public purchase: any;

  public serviceBookingType: any;

  public selectedSuggestion: any;

  public config: any;

  public serviceFees: any;
  // True when /fees answered 404 ("we could not price this") for the current
  // selection. While set, the journey must not show a price or start checkout —
  // an unpriced ceremony is not bookable online, it is NOT free.
  public feesUnavailable = false;
  public vatSplit = [];

  public serviceUnavailable: boolean;

  notify: Subject<boolean> = new Subject<boolean>();
  onNotify(event) {
    this.notify.next(true);
  }

  private addFeesSubject = new BehaviorSubject<any>(null);
  addFees$ = this.addFeesSubject.asObservable();
  triggerAddFees(fees: any) {
    this.addFeesSubject.next(fees);
  }
}
